import { ChangeDetectorRef, Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material'
import * as _ from 'lodash'
import { BaseDialogComponent } from '../../../../../../../base/dialog-base/dialog-base.component'
import { AppService, ConsultationService, CourrierService, DialogService, DocumentService, DossierService, FormulaireService, InstructionService, StateService, VisiteService } from '../../../../../../../services'
import { Observable, Subject } from 'rxjs'
import { PanierLine } from '../../../../../../../Interfaces/Panier'
import { ActivatedRoute, Router } from '@angular/router'
import { FormulaireDossierDialogComponent } from '../../../../../../../views/partials/layout/dialogs/formulaire-dossier-dialog/formulaire-dossier-dialog.component'
import { JSONRpcResponse } from '../../../../../../../Interfaces/JSONRpcResponse'
import { debounceTime, first } from 'rxjs/operators'
import { FormDialogFormulaireWithSFComponent } from '../../../../../../../motor-form-atyl/form-atyl-components/form-dialog/form-dialog-formulaire-with-sf/form-dialog-formulaire-with-sf.component'
import { EtapeinstructionComponent } from '../../../../../../../views/partials/layout/dialogs/etapeinstruction-dialog/etapeinstruction.component'
import { UploadFileDialogComponent } from '../../../../../../../views/partials/layout/dialogs/upload-file-dialog/upload-file-dialog.component'
import { ConfirmComponent } from '../../../../../../../motor-form-atyl/form-atyl-components/form-dialog/confirm/confirm.component'
import { InstructionPersonneComponent } from '../../../../../../../views/partials/layout/dialogs/instruction-personne-dialog/instruction-personne.component'
import { ChoiceCourrierComponent } from '../../../../../../../views/partials/layout/dialogs/choice-courrier-dialog/choice-courrier.component'
import { CreateConsultationDialogComponent } from '../../../../../../../views/partials/content/actions/create-consultation-dialog/create-consultation-dialog.component'
import { VisiteActionsDialog } from '../../../../../../../views/partials/content/actions/visite-actions-dialog/visite-actions-dialog.component'
import { CourrierDialog } from '../../../../../../../views/partials/layout/dialogs/courrier-dialog/courrier-dialog.component'
import { InstructionHistoriqueDialog } from '../../../../../../../views/partials/content/actions/instruction-historique-dialog/instruction-historique-dialog.component'
import { PrintDialog } from '../../../../../../../views/partials/layout/dialogs/print-dialog/print-dialog.component'
import { Stringable, StringableValues } from '../../../../../../../common/stringable.decorator'

const KEY = 'action-collective-instruction'

@Component({
	selector: 'atyl-action-collective-object-instruction',
	templateUrl: './une-instruction-object.component.html',
	styleUrls: ['./une-instruction-object.component.scss'],
})

@Stringable({
	path: 'views/pages/actioncollective/tabs/instruction',
	key: KEY,
})

export class ActionCollectiveDossierTabInstructionObjectComponent extends BaseDialogComponent implements OnInit {
	// @Input() events: Observable<void>
	events: Subject<boolean> = new Subject<boolean>();
	@Input() dossier: any
	@Input() tiers: any
	@Input() user: any

	@Output() change = new EventEmitter<any>();

	private eventsSubscription: any
	private eventReloadSubscription: any

	@Input() historique: boolean = false;
	@Input() eventReload: Observable<boolean>

	@Input() elementPanier: PanierLine[] = [];
	@StringableValues(KEY)

	strings: any
	listContacts: any = [];
	showBdate: boolean = false;
	nameString: string = '';
	sexString: string = '';
	adresse: any

	listInstructions: any[] = [];
	listInstructionsHisto: any[] = [];

	selectedInstruc: any = [];
	droits: any = [];
	cachedInstruc: any
	currentInstru: any

	isLoadInstruction: boolean = false;
	loadingInstruction: boolean = false;
	updDossier: boolean = true;

	private debounce: Subject<string> = new Subject();

	isCurrentInstructeur: boolean = true;

	page: any

	// displayedInstruction: any = [601, 536]

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: any,
		changeDetectorRef: ChangeDetectorRef,
		public dialogRef: MatDialogRef<any>,
		dialogService: DialogService,
		public dialog: MatDialog,
		private dossierService: DossierService,
		private formulaireService: FormulaireService,
		private instructionService: InstructionService,
		private appService: AppService,
		private documentService: DocumentService,
		private visiteService: VisiteService,
		private consultationService: ConsultationService,
		private courrierService: CourrierService,
		private stateService:StateService,
		private router: Router,
		private activatedRoute: ActivatedRoute,
	) {
		super(dialogRef, dialogService, changeDetectorRef)

		this.dossier = data.dossier
		this.tiers = data.tiers
		this.user = data.user
	}

	ngOnInit() {
		this.getInstructionLoad()
		// this.eventsSubscription = this.events.subscribe((notify: boolean) => {
		// })
	}

	ngOnDestroy() {
		if (this.eventsSubscription) this.eventsSubscription.unsubscribe()
		//this.eventReloadSubscription.unsubscribe()
	}

	getInstructionLoad(notify: boolean = true) {
		console.log("AAAA getInstructionLoad", this.dossier, this.historique);

		// if (!this.isLoadInstruction)
		{
			this.loadingInstruction = true
			let _options = {
				historique: this.historique,
				getAll: true
			}
			this.dossierService.getinstructionlist(this.dossier.ID, _options).pipe(first())
				.subscribe((instruction: JSONRpcResponse) => {
					instruction.result.instructions = this.setObjectUserRights(instruction.result.instructions, "instruction");
					this.dossier.instructions = instruction.result.instructions

					this.dossier.instructions_encours = [];
					this.dossier.instructions_historique = [];

					for (let i = 0; i < this.dossier.instructions.length; i++) {
						if (this.dossier.instructions[i].etape.historique)
							this.dossier.instructions_historique.push(this.dossier.instructions[i]);
						else
							this.dossier.instructions_encours.push(this.dossier.instructions[i]);
					}

					this.dossier.instructions = [];

					this.dossier.instructions = this.dossier.instructions.concat(this.dossier.instructions_encours)
					this.dossier.instructions = this.dossier.instructions.concat(this.dossier.instructions_historique)

					this.dossier.demandes = instruction.result.demandes
					this.dossier.documents = instruction.result.documents

					this.listInstructions = this.dossier.instructions

					if (this.cachedInstruc == undefined && this.listInstructions.length > 0)
						this.changeInstructionEnfant(this.listInstructions[0], 'Instruction')
					//if (notify)
					{
						let changeEmiiter = {
							historique: this.historique,
							instructions: this.listInstructions,
							notify: notify
						};
						this.change.emit(changeEmiiter);
					}
					/*
				   if (!this.eventReloadSubscription) 
						this.eventReloadSubscription = this.eventReload.subscribe((notify) =>
							   this.getInstructionLoad(notify));
						   ;
					*/

					this.isLoadInstruction = true
					this.loadingInstruction = false
					this.changeDetectorRef.detectChanges()
				}, (err: Error) => {
					console.log(err)
				}, () => {
					console.log('finish')

					console.log("AAAA", {
						listInstructions: this.listInstructions
					})
				})
		}

	}

	addForm(instru: any) {
		let droitform: any[] = [];
		if (this.droits.droits != undefined
			&& this.droits.droits.form != undefined
			/*&& this.droits.droits.form.length>0*/
		)
			droitform = this.droits.droits.form
		console.log('FormulaireDossierDialogComponent before addForm', droitform, this.droits.droits)
		this.dialogService.open(FormulaireDossierDialogComponent, {
			data: {
				instruction: instru,
				droits: droitform,
				droitsObjets: this.user.droitsObjets
			},
			minimizable: true,
			maximizable: true,
			draggable: true,
		}, (result) => {
			if (result) {
				let arrayId = []
				result.forEach((form) => {
					if (form.selected)
						arrayId.push(form.key)
				})
				this.formulaireService.init(arrayId, instru).subscribe((res: JSONRpcResponse) => {
					/* this.isLoadDossier=false;
					 this.isLoadAgrement=false;
					 this.isLoadFormation=false;
					 this.isLoadInstruction=false;
					 this.tabInstructionLoad();*/
					/*
					let changeEmiiter= {
							historique: this.historique,
							instructions: this.listInstructions,
							notify: false
						   };
					this.change.emit(changeEmiiter);*/

					this.changeInstructionEnfant(this.selectedInstruc, 'Instruction');

				})
				/*this.appService.setFormulaire(result.selectedForm, instru).subscribe((res) => {
				   this.isLoadDossier=false;
				   this.isLoadAgrement=false;
				   this.isLoadFormation=false;
				   this.isLoadInstruction=false;
					 this.tabInstructionLoad();
				});*/
			}
		})
	}

	getDroit(instruction: any) {
		let _options = {

		}
		instruction.commentaire = null;
		this.instructionService.droit(instruction.ID, _options).subscribe((res: JSONRpcResponse) => {


			this.droits = res.result;

			if (this.droits.commentaire != undefined
				&& this.droits.commentaire
				&& this.droits.commentaire.length > 0
			)
				instruction.commentaire = this.droits.commentaire


			console.log(' get droit', instruction, this.droits);
			this.changeDetectorRef.detectChanges();
		});
	}


	changeInstructionEnfant(instruction: any, type: any) {
		//this.updInstruc = false;
		//this.updDossier = true;
		this.elementPanier = []
		let line: PanierLine = new PanierLine();
		if (this.dossier)
			if (this.dossier.tiers)
				line.dossier = this.dossier.tiers
		if (instruction)
			line.instruction = instruction
		this.elementPanier.push(line);
		console.log('this.elementPanier ', this.elementPanier)

		let instru = { ...instruction }
		if (!instru.demande.type)
			instru.demande.type = { ID: '' }

		this.selectedInstruc = instru
		this.selectedInstruc.expandForm = true
		this.selectedInstruc.expandCour = true
		this.selectedInstruc.expandRDV = true
		this.selectedInstruc.expandDoc = true
		this.cachedInstruc = instru.ID



		this.currentInstru = this.selectedInstruc
		this.getDroit(this.currentInstru);

		this.isCurrentInstructeur = (
			this.currentInstru.instructeur != undefined
			&& this.currentInstru.instructeur.ID > 0
			&& this.user != undefined
			&& this.user.id > 0
			&& this.currentInstru.instructeur.ID == this.user.id
		);
		console.log("ActionCollectiveDossierTabOneInstructionComponent changeInstructionEnfant", this.isCurrentInstructeur, this.currentInstru, this.user)

		instru.debutdate = new Date(instru.debutdate)

		this.formulaireService.demandes(instruction.demande.ID, false)
			.pipe(first())
			.subscribe((forms: JSONRpcResponse) => {
				let tempForms = []
				let rdvForms = []
				instru.selectedForms = forms.result;

				let droitform: any[] = [];
				if (this.droits.droits != undefined
					&& this.droits.droits.form != undefined
					/*&& this.droits.droits.form.length>0*/
				)
					droitform = this.droits.droits.form
				let fs: any = [];
				forms.result.forEach((f) => {
					let added: boolean = true;
					f.editable = true;
					//console.log("formulaireService dorit before",droitform,f) 
					if (
						f.form != undefined
						&& f.form.key != undefined
						&& f.form.key
						&& droitform[f.form.key] != undefined
						&& droitform[f.form.key].r != undefined

					) {
						//	console.log("formulaireService dorit r",droitform[f.form.key],f) 
						if (!droitform[f.form.key].r)
							added = false;
					}

					if (
						f.form != undefined
						&& f.form.key != undefined
						&& f.form.key
						&& droitform[f.form.key] != undefined
						&& droitform[f.form.key].w != undefined

					) {
						f.editable = droitform[f.form.key].w;

					}
					this.setObjectUserRights(f, "formulaire")

					if (added)
						fs.push(f);

				});
				instru.selectedForms = fs;
				/*forms.result.forEach((form) => {
					if (form.form && (form.form.type === 0 || form.form.type === 3 || form.form.type === 5))
						tempForms.push(form)
					else if (form.form && form.form.type === 1)
						rdvForms.push(form)
				})
				instru.selectedForms = tempForms
				instru.selectedRDV = rdvForms
				
				
				
				instru.selectedRDV.forEach(element => {
					if (element.form && element.form.fields && element.form.fields.length > 0) {
						element.form.fields.forEach((field) => {
							if (field.field && (field.field.key === 'RENDEZVOUS_DATE' || field.field.key === 'DATEWITHTIME')) {
								element.timeRDV = field.value
							}
						})
					}
				})
			/instru.selectedRDV = _.orderBy(instru.selectedRDV, 'timeRDV', ['desc'])
			*/
				this.changeDetectorRef.detectChanges()
			})


		this.changeDetectorRef.detectChanges()

		let professions: any[] = [];
		instruction.type.professions.forEach(element => {
			professions.push(element.key);
		});

		this.debounce.pipe(
			debounceTime(1000)
		).subscribe(search => {
			if (search.length > 0) {
				this.appService.getUsersByProfressions(professions, this.dossier.ID, search).subscribe((result) => {
					instru.possibleTiers = result.result;
					this.changeDetectorRef.detectChanges();
				});
			}

		});


		this.appService.getListDocumentsForInstruction(instruction.ID).pipe(first()).subscribe((res: JSONRpcResponse) => {
			instru.documents = res.result;

			let droitdoc: any[] = [];
			if (this.droits.droits != undefined
				&& this.droits.droits.document != undefined
				/*&& this.droits.droits.form.length>0*/
			)
				droitdoc = this.droits.droits.document

			let ds: any = [];
			res.result.forEach((d) => {
				let added: boolean = true;
				d.editable = true;
				// console.log("getListDocumentsForInstruction dorit before",droitdoc,d,
				// d.document.type,d.document.type.key, droitdoc[d.document.type.key])

				if (
					d.document != undefined
					&& d.document.type != undefined
					&& d.document.type.key != undefined
					&& d.document.type.key
					&& droitdoc[d.document.type.key] != undefined
					&& droitdoc[d.document.type.key].r != undefined

				) {
					//	console.log("getListDocumentsForInstruction dorit r",droitdoc[d.document.type.key],d) 
					if (!droitdoc[d.document.type.key].r)
						added = false;
				}

				if (
					d.document != undefined
					&& d.document.type != undefined
					&& d.document.type.key != undefined
					&& d.document.type.key
					&& droitdoc[d.document.type.key] != undefined
					&& droitdoc[d.document.type.key].w != undefined

				) {
					d.editable = droitdoc[d.document.type.key].w;
					//  console.log("getListDocumentsForInstruction dorit w",droitdoc[d.document.type.key],d)   

				}
				this.setObjectUserRights(d, "document")
				if (added)
					ds.push(d);

			});
			instru.documents = ds;


			this.changeDetectorRef.detectChanges();
		});

		this.appService.getListCourrier(instru.demande).pipe(first()).subscribe((res: JSONRpcResponse) => {
			//instru.courriers = res.result;

			let droitcourier: any[] = [];
			if (this.droits.droits != undefined
				&& this.droits.droits.courrier != undefined
				/*&& this.droits.droits.form.length>0*/
			)
				droitcourier = this.droits.droits.courrier

			let cs: any = [];
			res.result.forEach((c) => {
				let added: boolean = true;
				c.editable = true;
				console.log("getListCourrier droit before", droitcourier, c,
					c.courrier, c.courrier.key, droitcourier[c.courrier.key])

				if (
					c.courrier != undefined
					&& c.courrier.key != undefined
					&& droitcourier[c.courrier.key] != undefined
					&& droitcourier[c.courrier.key].r != undefined

				) {
					console.log("getListCourrier droit r", droitcourier[c.courrier.key], c)
					if (!droitcourier[c.courrier.key].r)
						added = false;
				}

				if (
					c.courrier != undefined
					&& c.courrier.key != undefined
					&& droitcourier[c.courrier.key] != undefined
					&& droitcourier[c.courrier.key].w != undefined

				) {
					c.editable = droitcourier[c.courrier.key].w;
					console.log("getListCourrier droit w", droitcourier[c.courrier.key], c)

				}
				this.setObjectUserRights(c, "courrier")
				if (added)
					cs.push(c);

			});

			instru.courriers = cs;

			this.changeDetectorRef.detectChanges();
		});
		if (instru.type.visite) {
			this.visiteService.getVisitesByInstruction(instru.ID, {all: true}).pipe(first()).subscribe((res) => {
				instru.visites = this.setObjectUserRights(res.result, "visite");
				console.log("getVisitesByInstruction", instru);
				this.changeDetectorRef.detectChanges();
			});
		} else {
			this.consultationService.getListByInstruction(instru.ID).pipe(first()).subscribe((res) => {
				instru.consultations = this.setObjectUserRights(res.result, "consultation");
				console.log("getConsutlmionByInstruction", instru);
				this.changeDetectorRef.detectChanges();
			});
		}

	}

	displayAutoSelectListInstru(key?: any): string | undefined {
		let selected
		if (this.selectedInstruc && this.selectedInstruc.possibleTiers) {
			this.selectedInstruc.possibleTiers.forEach((select) => {
				if (key && select.ID === key.ID)
					selected = select
			})
		}
		return selected ? selected.NOM + ' ' + (selected.PRENOM ? selected.PRENOM : '') : undefined
	}

	canShowButton(instru: any) {
		let instructionTypeID = instru.type.ID
		/*if(this.tierAccess && this.tier && this.tier.type !== 'CCPD' && instru.transmission)
		  return !this.tierAccess.includes(instructionTypeID);
		else
		  return false;*/
		return true
	}

	countFormsAfterDroits(forms) {
		let count = 0
		forms.forEach((form) => {
			count++
		})
		return count
	}

	countDocsAfterDroits(documents) {
		let count = 0;
		documents.forEach((doc) => {
			if (doc.ID)
				count++;
		});
		return count;
	}

	countRdvAfterDroits(visites) {
		// console.log("countRdvAfterDroits",visites)
		let count = 0;
		if (visites) {
			visites.forEach((visite) => {
				if (visite.ID)
					count++;
			})
		}
		return count;
	}

	countCourAfterDroits(courriers) {

		let count = 0;
		courriers.forEach((cour) => {
			if (cour.ID)
				count++;
		})
		return count;
	}

	download(url: string) {
		window.open(url, ' _blank');
	}

	formationDialog(typeFormulaire: string, libelle: string, form?: any, demandeForm?: any, editable = true, typeInstru?: any) {
		let dialogRef: any;

		console.log("formationDialog", typeFormulaire, editable);
		if (form && form.under_form && form.under_form.length === 0) {

			/*let datasF = {
				typeFormulaire: typeFormulaire,
				dossierId: this.dossier.ID,
				title: libelle,
				form: form,
				instruction: this.currentInstru,
				demandeFormulaire: demandeForm,
				isEditable: true
			}			}
			*/
			let datasF = {
				title: form.libelle,
				id: demandeForm.ID,
				formType: demandeForm.key,
				idDemandeForm: form.ID,
				instruction: this.currentInstru,
				isEditable: editable
			}
			datasF['dossier'] = this.dossier

			dialogRef = this.dialogService.open(FormDialogFormulaireWithSFComponent, {
				data: datasF,
				height: '90vh',
				width: "90vw",
				resizable: true,
				minimizable: true,
				draggable: true,
				maximizable: true
			}, result => {
				this.isLoadInstruction = false
				/*this.isLoadAgrement = false;
				this.isLoadFormation = false;
				this.lastAgrement = undefined;
				this.lastFormation = undefined;
		*/
				/*   this.isLoadDossier=false;*/
				/* this.reloadDossier();*/

			})

		}
		else if (form && form.under_form && form.under_form.length > 0) {
			let datasF = {
				title: libelle,
				id: demandeForm.ID,
				formType: demandeForm.key,
				instruction: this.currentInstru,
				idDemandeForm: form.ID,
				isEditable: editable
				/* isEditable: editable && this.updDossier && (form.all_rights || form.readAndWrite ? true : false)*/
			}
			datasF['dossier'] = this.dossier

			dialogRef = this.dialogService.open(FormDialogFormulaireWithSFComponent, {
				data: datasF,
				height: '90vh',
				width: "90vw",
				resizable: true,
				minimizable: true,
				draggable: true,
				maximizable: true,

			}, (result: any) => {
				this.isLoadInstruction = false
				/*
							this.isLoadDossier=false;
						this.reloadDossier();
						*/

			})
		}
		if (dialogRef) {
			dialogRef.afterClosed().subscribe(result => {
				if (result && result != "") {
					this.changeInstructionEnfant(this.currentInstru, 'Instruction');

				}


			});
		}
	}

	changeInstructionEtape() {
		this.currentInstru = this.selectedInstruc;
		this.dialogService.open(EtapeinstructionComponent, {
			data: {
				instruction: this.currentInstru,
				iddossier: this.dossier.ID
			}
		}, (res: any) => {
			//  if(res.etape && res.instructeur){
			if (res.etape) {
				console.log("res close changeInstructionEtape", res)
				/* this.selectedInstruc=res;*/
				this.currentInstru.transitionid = res.etape.key
				//this.currentInstru.instructeurid = res.instructeur.ID;
				this.currentInstru.comment = res.comment ? res.comment : ''
				this.currentInstru.titre = res.titre ? res.titre : ''
				this.currentInstru.transition_demande_type = res.transition_demande_type ? res.transition_demande_type : null
				if (res.instructeur)
					this.currentInstru.instructeurid = res.instructeur.ID

				this.instructionService.setTransitionInstruction(this.currentInstru).subscribe((resu: JSONRpcResponse) => {
					console.log("res close changeInstructionEtape change", resu)
					if (resu.result) {
						this.selectedInstruc = resu.result;
						this.changeInstructionEnfant(this.selectedInstruc, 'Instruction');
					}
					this.isLoadInstruction = false
					this.getInstructionLoad()
				})


			}

		})


	}

	cancelInstruction() {
		this.dialogService.open(ConfirmComponent, {
			data: {
				libelle: this.strings.confirmMessages.stopProcedure
			},
			draggable: true,
		}, (res: any) => {
			if (res === 'true') {
				this.instructionService.annuler(this.currentInstru.ID).subscribe((res: JSONRpcResponse) => {
					this.isLoadInstruction = false
					this.getInstructionLoad()
				})
			}
		})
	}

	triggerAutocompSelectionList(search: any) {
		this.debounce.next(search);
	}

	updateInstructeurToUser(instruction: any) {
		this.currentInstru = this.selectedInstruc;
		console.log("updateInstructeurToUser before", instruction, this.currentInstru)
		this.dialogService.open(InstructionPersonneComponent, {
			data: {
				instruction: instruction,
				iddossier: this.dossier.ID,
				user: this.user
			}
		}, (res: any) => {

			if (res.instructeur) {
				console.log("res close InstructionPersonneComponent ", res)

				instruction.comment = res.comment ? res.comment : null
				instruction.titre = res.titre ? res.titre : null
				if (res.instructeur)
					if (res.instructeur.id != undefined)
						instruction.instructeurid = res.instructeur.id
					else
						instruction.instructeurid = res.instructeur.ID

				this.isCurrentInstructeur = (
					instruction.instructeurid != undefined
					&& instruction.instructeurid > 0
					&& this.user != undefined
					&& this.user.id > 0
					&& instruction.instructeurid == this.user.id
				);
				console.log("updateInstructeurToUser to update", instruction)
				this.appService.setInstruction(instruction).subscribe((res) => {
					this.isLoadInstruction = false

					this.getInstructionLoad()
				});

			}

		})



	}

	addDocument(documents: any) {

		let droitdoc: any[] = [];
		if (this.droits.droits != undefined
			&& this.droits.droits.document != undefined
			/*&& this.droits.droits.form.length>0*/
		)
			droitdoc = this.droits.droits.document

		const dialogRef = this.dialog.open(UploadFileDialogComponent, {
			data: {
				instruction: this.currentInstru,
				documents: documents,
				droits: droitdoc,
				droitsObjets: this.user.droitsObjets

			},
			width: "32vw"
		});
		dialogRef.afterClosed().subscribe(result => {
			if (result != undefined && result != "") {

				let document: any = {
					ID: 0,
					demandeid: this.currentInstru.demande.ID,
					document: result.selectedDocument.document,
					value: result.selectedDocument.value,
					desciption: null,
					status: result.currentEtat,
					parameter: result.selectedDocument.parameter,
					formulaires: result.selectedFormulaires
				}
				document.value.parameter = result.selectedDocument.parameter

				if (result.selectedDocument.description)
					document.value.description = result.selectedDocument.description.replace(/<[^>]*>/g, '');;
				console.log("before document", document, document.demandeid, document, this.dossier.ID, this.currentInstru.demande.type.ID)
				this.documentService.setDocumentByInstruction(
					document.demandeid, document, this.dossier.ID, this.currentInstru.demande.type.ID).subscribe((res: JSONRpcResponse) => {
						console.log("after document", res)
						this.stateService.documentsUpdate(true)
						this.changeInstructionEnfant(this.selectedInstruc, 'Instruction');
					})


			}
		});
	}

	uploadeDialog(document: any, editable = true) {
		console.log("uploadeDialog", document, editable)
		const dialogRef = this.dialog.open(UploadFileDialogComponent, {
			data: {
				instruction: this.currentInstru,
				document: document,
				isEditable: editable
				/*documents: this.allDocumentsDossier,
				isEditable: editable && this.updDossier && (document.all_rights || document.readAndWrite ? true : false),
				droits: this.droits*/
			},
			width: "30vw"
		});
		dialogRef.afterClosed().subscribe(result => {
			if (result && result != "") {

				let dct: any = {
					ID: document.ID,
					demandeid: this.currentInstru.demande.ID,
					document: result.selectedDocument.document,
					value: result.selectedDocument.value,
					desciption: null,
					status: result.currentEtat,
					parameter: result.selectedDocument.parameter,
					formulaires: result.selectedFormulaires
				}
				document.value.parameter = result.selectedDocument.parameter

				if (result.selectedDocument.description)
					document.value.description = result.selectedDocument.description.replace(/<[^>]*>/g, '');;

				if (result.selectedDocument.demandeID) {
                    document.demandeid = result.selectedDocument.demandeID;
                }

				/*document.value = result.selectedDocument.value;
				document.value.parameter = result.selectedDocument.parameter;
				document.value.description = result.selectedDocument.description.replace(/<[^>]*>/g, '');;
				document.value.archive = JSON.parse(result.archive);
				document.status = result.currentEtat;*/
				console.log("setDocumentByInstruction", document.demandeid, document, this.dossier.ID, this.currentInstru.demande.type.ID)

				this.documentService.setDocumentByInstruction(document.demandeid, document, this.dossier.ID, this.currentInstru.demande.type.ID).subscribe((res: JSONRpcResponse) => {
					console.log("after document", res)
					this.stateService.documentsUpdate(true)
					this.changeInstructionEnfant(this.currentInstru, 'Instruction');
				})
				/*(document.demandeid ? document.demandeid : this.currentInstru.demande.ID, document).subscribe((res) => {
				  //this.reloadDossier();
				  this.isLoadInstruction=false;
				  this.tabInstructionLoad();
				});*/
			}
		});
	}

	getChoiceCourrier(instruction: any): void {
		let droitcourier: any[] = [];
		if (this.droits.droits != undefined
			&& this.droits.droits.courrier != undefined
			/*&& this.droits.droits.form.length>0*/
		)
			droitcourier = this.droits.droits.courrier

		const dialogRef = this.dialogService.open(ChoiceCourrierComponent, {
			data: {
				instruction: instruction,
				demandeType: instruction.demande,
				typeDemande: instruction.demande,
				/*  state: this.currentState,*/
				dossier: this.dossier,
				droits: droitcourier,
				droitsObjets: this.user.droitsObjets
			},
			/* width: "50vw",*/
			resizable: true,
			minimizable: true,
			draggable: true,
			maximizable: true
		});
		dialogRef.afterClosed().subscribe((result) => {
			console.log("ActionCollectiveDossierTabOneInstructionComponent ChoiceCourrierComponent", result);
			if (result) {


				if (result != undefined && result
					&& result.zipFile != undefined
					&& result.zipFile.url != undefined
					&& result.zipFile.url
				) {
					window.open(result.zipFile.url, ' _blank');
				}
				/*this.isLoadDossier=false;
				this.isLoadAgrement=false;
				this.isLoadFormation=false;
				this.isLoadInstruction=false;      
				  this.tabInstructionLoad();*/
				// this.reloadDossier();

			}
		});

		const sub = dialogRef.componentInstance.onFormClosed.subscribe((result: any) => {
			console.log('createCouurierDialog after form refesh', result);
			if (result) {
				if (result != undefined && result
					&& result.zipFile != undefined
					&& result.zipFile.url != undefined
					&& result.zipFile.url
				) {
					window.open(result.zipFile.url, ' _blank');
				}

				this.changeInstructionEnfant(this.selectedInstruc, 'Instruction');
			}
		}
		)

	}

	getCourrier(instruction: any, courrier?: any, editable = true): void {
		console.log("getCourrier", courrier, editable);
		const dialogRef = this.dialogService.open(CourrierDialog, {
			data: {
				dossier: this.dossier,
				instruction: instruction,
				courriers: instruction.courriers,
				demande: instruction.demande,
				courrier: courrier,
				isEditable: editable,
				demandeId: courrier.ID
			},
			width: "80vw",
			resizable: true,
			minimizable: true,
			draggable: true,
			maximizable: true
		});

		dialogRef.afterClosed().subscribe(result => {
			console.log("getCourrier close", result)
			if (result) {
				//this.reloadDossier();
				this.isLoadInstruction = false;

				if (result != undefined && result
					&& result.ziFile != undefined
					&& result.ziFile.url != undefined
					&& result.ziFile.url
				) {
					window.open(result.zipFile.url, ' _blank');
				}

				this.changeInstructionEnfant(this.selectedInstruc, 'Instruction');
			}
		});
	}
	createConsultation(instruction: any): void {
		this.consultationService.getConsultationTypeList().subscribe((res: JSONRpcResponse) => {
			let dataCs = {
				action: "create",
				dataType: "consultation",
				instruction: instruction,
				dossier: this.dossier,
				title: "Création d'une consultation",
				create: true,
				types: res.result,
				droitsObjets: this.user.droitsObjets
			}
			const dialogRef = this.dialogService.open(CreateConsultationDialogComponent, {
				data: dataCs,
				height: "90vh",
				width: "80vw",
				draggable: true,
				resizable: true,
				minimizable: true,
				maximizable: true,
			})

			dialogRef.afterClosed().subscribe(result => {
				if (result) {
					//this.reloadDossier();
					// this.isLoadInstruction=false;
					this.changeInstructionEnfant(instruction, 'Instruction');
				}
			});

		});
	}
	createVisite(instruction: any): void {
		console.log("createVisite instruction:", instruction);
		const dialogRef = this.dialogService.open(VisiteActionsDialog, {
			data: {
				action: "create",
				dataType: "rdv",
				dossier: this.dossier,
				instruction: instruction,
				title: "Création d'un rendez-vous",
				create: true,
				droitsObjets: this.user.droitsObjets

			},
			height: "95vh",
			width: "80vw",
			draggable: true,
			resizable: true,
			minimizable: true,
			maximizable: true,
		})

		dialogRef.afterClosed().subscribe(result => {
			if (result) {
				//this.reloadDossier();
				// this.isLoadInstruction=false;
				this.changeInstructionEnfant(instruction, 'Instruction');
			}
		});
	}

	getVisite(instruction: any, visite: any) {
		console.log("getVisite", instruction, visite)
		this.stateService.updateConsultation(visite.visite.consultation);
		this.stateService.pages.subscribe((pages) => {
			pages.forEach(element => {
				//if(element.key == "DOSSIERCONSULATION"){
				this.page = element;
				//}
			});
		})
		const dialogRef = this.dialogService.open(VisiteActionsDialog, {
			data: {

				visite: visite.visite,
				title: "Modification d'un rendez-vous",
				professionels: visite.visite.professionels.string,
				page: this.page,
				create: false,
				allowPopup: true,
				dossier: this.dossier,
				visiteEditable: visite.editable
			},
			height: "95vh",
			width: "80vw",
			draggable: true,
			resizable: true,
			minimizable: true,
			maximizable: true,
		})

		dialogRef.afterClosed().subscribe(result => {
			if (result) {
				//this.reloadDossier();
				// this.isLoadInstruction=false;
				this.changeInstructionEnfant(instruction, 'Instruction');
			}
		});

	}


	openConsultation(instruction: any, consultation: any) {
		console.log("open consultation", consultation);
		this.router.navigate(['/home/consultation/' + consultation.ID], {
			relativeTo: this.activatedRoute
		})

	}

	getConsultation(instruction: any, consultation: any) {
		this.consultationService.getConsultationTypeList().subscribe((res: JSONRpcResponse) => {
			console.log("creationConsultation res:", res, "\nconsultation:", consultation);
			let dataCs = {
				action: "create",
				dataType: "consultation",
				consultation: consultation,
				dossier: this.dossier,
				title: "Création d'une séance",
				page: "bilan seance",
				create: true,
				types: res.result,
				droitsObjets: this.user.droitsObjets
			}
			this.dialogService.open(CreateConsultationDialogComponent, {
				data: dataCs,
				height: "95vh",
				width: "80vw",
				draggable: true,
				maximizable: true,
				minimizable: true,
				resizable: true,
			}, (res: any) => {
				console.log(res)
				this.changeInstructionEnfant(instruction, 'Instruction');
				/* let _refresh={
					 type: "consultation",
					 data:res
				 };
			    
				 this.stateService.updateRefresh(_refresh)*/

			})
			this.changeDetectorRef.detectChanges()
		})

	}

	updateInstructeurInstruction(instructeur: any) {
		let pastInstruc = this.currentInstru.instructeur;
		let toConfirm = true;
		Object.keys(this.user.droits).forEach((droit) => {
			if (droit === "AUCUNE_CONFIRMATION" || droit === "AUCUNE_CONFIRMATION_UTILISATEUR") {
				toConfirm = false;
			}
		})
		if (toConfirm) {
			const confDialogRef = this.dialog.open(ConfirmComponent, {
				data: {
					libelle: 'Etes-vous sur de vouloir changer la personne en charge ?'
				}
			});
			confDialogRef.afterClosed().subscribe(res => {
				if (res === "true") {
					//this.updInstruc = true;
					this.currentInstru.instructeurid = instructeur.ID;
					this.appService.setInstruction(this.currentInstru).subscribe((res) => {
						// this.updInstruc = false;
						this.isLoadInstruction = false;
						// this.tabInstructionLoad();
						//this.reloadDossier();
						this.changeInstructionEnfant(this.currentInstru, 'Instruction');
					});
				}
				else
					this.currentInstru.selectedTier = pastInstruc;
			});
		}
		else {
			//this.updInstruc = true;
			this.currentInstru.instructeurid = instructeur.ID;
			this.appService.setInstruction(this.currentInstru).subscribe((res) => {
				// this.updInstruc = false;
				this.isLoadInstruction = false;
				//  this.tabInstructionLoad();
				this.changeInstructionEnfant(this.currentInstru, 'Instruction');
				//this.reloadDossier();
			});
		}
	}



	printFormulaire(event: any, formulaire: any) {
		this.dialogService.open(PrintDialog, {
			data: {
				formulaire: formulaire,
				dossier: this.dossier,

			},
			draggable: false,
			resizable: false,
		})
	}

	openHistorique() {
		this.dialogService.open(InstructionHistoriqueDialog, {
			data: {
				instruction: this.currentInstru,
				dossier: this.dossier
			},
			draggable: false,
			resizable: false,
			/*	height: "50vh",*/
			width: "40vw"
		}
		);
	}

	deleteCourrier(demandeCourrier: any) {
		if (demandeCourrier) {
			this.dialogService.open(ConfirmComponent, {
				data: {
					libelle: this.strings.confirmMessages.deleteCourrier
				},
				draggable: true,
			}, (res: any) => {
				if (res && res === 'true') {
					this.courrierService.setCourrierDelete(demandeCourrier.ID).subscribe((forms: JSONRpcResponse) => {
						this.stateService.courriersUpdate(true)
						console.log(demandeCourrier.status)
						this.changeInstructionEnfant(this.selectedInstruc, 'Instruction');

					})
				}
			})
		}
	}

	restoreCourrier(demandeCourrier: any) {
		if (demandeCourrier) {
			this.dialogService.open(ConfirmComponent, {
				data: {
					libelle: this.strings.confirmMessages.restoreCourrier
				},
				draggable: true,
			}, (res: any) => {
				if (res && res === 'true') {
					this.courrierService.setCourrierRestore(demandeCourrier.ID).subscribe((forms: JSONRpcResponse) => {
						this.stateService.courriersUpdate(true)
						this.changeInstructionEnfant(this.selectedInstruc, 'Instruction');
					})
				}
			})
		}
	}

	deleteDocument(demandeDoc: any) {
		if (demandeDoc) {
			this.dialogService.open(ConfirmComponent, {
				data: {
					libelle: this.strings.confirmMessages.deleteDocument
				},
				draggable: true,
			}, (res: any) => {
				if (res && res === 'true') {
					this.documentService.setDocumentDelete(demandeDoc.ID).subscribe((forms: JSONRpcResponse) => {
						this.stateService.documentsUpdate(true)
						this.changeInstructionEnfant(this.selectedInstruc, 'Instruction');
					})
				}
			})
		}
	}

	restoreDocument(demandeDoc: any) {
		if (demandeDoc) {
			this.dialogService.open(ConfirmComponent, {
				data: {
					libelle: this.strings.confirmMessages.restoreDocument
				},
				draggable: true,
			}, (res: any) => {
				if (res && res === 'true') {
					this.documentService.setDocumentRestore(demandeDoc.ID).subscribe((forms: JSONRpcResponse) => {
						this.stateService.documentsUpdate(true)
						this.changeInstructionEnfant(this.selectedInstruc, 'Instruction');
					})
				}
			})
		}
	}

	deleteFormulaire(demandeFormulaire: any) {

		this.dialogService.open(ConfirmComponent, {
			data: {
				libelle: this.strings.confirmMessages.deleteFormulaire
			},
			draggable: false,
			resizable: false,
		}, (res: any) => {
			if (res === 'true') {
				this.formulaireService.disableForm(demandeFormulaire.ID).subscribe((res: JSONRpcResponse) => {
					/*if (res.result)
						this.refresh.emit(res.result);
					*/
					this.changeInstructionEnfant(this.selectedInstruc, 'Instruction');
				})
			}
		})
	}

	lockForm(form: any, etat: number) {
		if (this.updDossier) {
			let s: string = (etat == 1) ? "verrouiller" : "déverrouiller";
			const confDialogRef = this.dialog.open(ConfirmComponent, {
				data: {
					libelle: 'Etes-vous sur de vouloir ' + s + ' ce formulaire ?'
				}
			});
			confDialogRef.afterClosed().subscribe(res => {
				if (res === 'true') {
					this.instructionService.lock(form.ID, etat).subscribe((res) => {
						this.changeInstructionEnfant(this.selectedInstruc, 'Instruction');
					});
				}
			});

		}
	}

	setObjectUserRights(obj: any | any[], type: string) {
		if (Array.isArray(obj)) {
			obj.forEach((item: any) => {
				item = this.applyRightsObj(item, type);
			});
		} else {
			obj = this.applyRightsObj(obj, type);
		}
		return obj;
	}

	applyRightsObj(obj: any, type: string) {
		let rg: any = {
			r: true,
			w: true,
			x: true
		};
		let key = null;

		switch (type) {
			case "formulaire":
				if (obj.form != undefined)
					key = obj.form.key;
				break;
			case "document":
				if (obj.document != undefined && obj.document.type != undefined)
					key = obj.document.type.key;
				break;
			case "visite":
				if (obj.visite != undefined && obj.visite.consultation.type != undefined)
					key = obj.visite.consultation.type.key;
				type = "consultation";
				break;
			case "consultation":
				if (obj.consultation != undefined && obj.consultation.type != undefined)
					key = obj.consultation.type.key;
				break;
			case "courrier":
				if (obj.courrier != undefined)
					key = obj.courrier.key;
				break;
			case "instruction":
				if (obj.type != undefined)
					key = obj.type.key;
				break;
		}

		if (this.user.droitsObjets != undefined && this.user.droitsObjets[type] != undefined) {
			if (this.user.droitsObjets[type][key] != undefined) {
				rg = this.user.droitsObjets[type][key];
			}
		}

		//vérifie les droits de l'instruction
		if (type != "instruction" && this.selectedInstruc && this.selectedInstruc.rights) {
			let newRights = {};
			for (let right of ["r", "w", "x"]) {
				newRights[right] = rg[right] ? this.selectedInstruc.rights[right] : false
			}
			rg = newRights;
		}

		obj.rights = rg;

		if (obj.editable || obj.editable == undefined) {
			obj.editable = rg.w;
		}
		return obj;
	}
	
	lock_unlock(form:any) {
		   console.log("form lock event_unlock",form)
			this.changeInstructionEnfant(this.selectedInstruc, 'Instruction');
	}
}
